import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage/wagebatchinfo' : '/wage/wagebatchinfo'

// 订单第一步，将订单附件上传到服务器
export function addorderattr(data) {
  return request({
    url: urlPrefix + '/addorderattr',
    method: 'post',
    data
  })
}

// 创建订单，做计算
export function addorder(data) {
  return request({
    url: urlPrefix + '/addorder',
    method: 'post',
    data
  })
}

// 订单接单
export function acceptorder(data) {
  return request({
    url: urlPrefix + '/acceptorder',
    method: 'post',
    data
  })
}

// 订单退回或者主动取回
export function rejectorder(data) {
  return request({
    url: urlPrefix + '/rejectorder',
    method: 'post',
    data
  })
}

// 订单修改
export function updateorder(data) {
  return request({
    url: urlPrefix + '/updateorder',
    method: 'post',
    data
  })
}

// 删除订单
export function deleteOrder(data) {
  return request({
    url: urlPrefix + '/deleteOrder',
    method: 'post',
    data
  })
}

// 预览工资单-邮件
export function previewpayslipemail(data) {
  return request({
    url: urlPrefix + '/previewpayslipemail',
    method: 'post',
    data
  })
}

// 预览工资单-邮件
export function previewpayslipphone(data) {
  return request({
    url: urlPrefix + '/previewpayslipphone',
    method: 'post',
    data
  })
}

// 查询订单
export function selectOrder(data) {
  return request({
    url: urlPrefix + '/selectOrder',
    method: 'post',
    data
  })
}

// 查询订单详情
export function selectOrderDetailForView(data) {
  return request({
    url: urlPrefix + '/selectOrderDetailForView',
    method: 'post',
    data
  })
}

// 发票列表查询
export function queryInvoiceList(data) {
  return request({
    url: urlPrefix + '/queryInvoiceList',
    method: 'post',
    data
  })
}

// 查询订单中工资条信息
export function getBizSalaryPayrollByPage(data) {
  return request({
    url: urlPrefix + '/getBizSalaryPayrollByPage',
    method: 'post',
    data
  })
}

// 查询订单中评价信息
export function getOrderCriticalInfo(data) {
  return request({
    url: urlPrefix + '/getOrderCriticalInfo',
    method: 'post',
    data
  })
}

// 设置订单中评价信息
export function setOrderCriticalInfo(data) {
  return request({
    url: urlPrefix + '/setOrderCriticalInfo',
    method: 'post',
    data
  })
}

// 查询订单中发薪信息
export function getBizSalaryByPage(data) {
  return request({
    url: urlPrefix + '/getBizSalaryByPage',
    method: 'post',
    data
  })
}

// 查询订单中缴税信息
export function getBizSalaryTaxByPage(data) {
  return request({
    url: urlPrefix + '/getBizSalaryTaxByPage',
    method: 'post',
    data
  })
}

// 下载发票
export function getTaxPicture(data) {
  return request({
    url: urlPrefix + '/getTaxPicture',
    method: 'post',
    headers: {
      ignoreAuth: true
    },
    data
  })
}

// 获取账单信息
export function getBillInfo(id) {
  return request({
    url: `/fsp-biz/ignore-auth/hr-cloud-bill/getBillById?id=${id}`,
    method: 'get',
    headers: {
      ignoreAuth: true
    }
  })
}

// 获取账单汇总信息
export function getBillSummaryInfo(data) {
  return request({
    url: `${urlPrefix}/getBillSummaryInfo/${data.cusId}/${data.billId}`,
    method: 'get',
    headers: {
      ignoreAuth: true
    }
  })
}

// 通过批次ID获取薪资列表的表头信息
export function getBillHeader(id) {
  return request({
    url: `/biz/batchInfo/noticeListHeader?templateId=1&batchId=${id}`,
    method: 'get',
    headers: {
      ignoreAuth: true
    }
  })
}

// 获取账单薪资明细列表
export function getBillDetail(data) {
  return request({
    url: '/biz/batchInfo/getBillsalaryDetail',
    method: 'post',
    headers: {
      ignoreAuth: true
    },
    data
  })
}

//账单明细导出
export function exportNoticeDetail(data){
  return request({
    url: '/biz/batchInfo/export',
    method: 'post',
    responseType: 'arraybuffer',
    headers: {
      ignoreAuth: true
    },
    data
  })
}

// 下载发票
export function downloadInvoice(id) {
  return request({
    url: `/wage/invoice/downloadInvoice?invoiceId=${id}`,
    method: 'get',
    responseType: 'arraybuffer',
    headers: {
      ignoreAuth: true
    }
  })
}

// 退票列表分页查询
export function refundlistpage(data) {
  return request({
    url: '/wage/refund/refundlistpage',
    method: 'post',
    data
  })
}

// 更新退票信息
export function updaterefundinfo(data) {
  return request({
    url: '/wage/refund/updaterefundinfo',
    method: 'post',
    data
  })
}

// 下载工资条
export function downloadPayslip(data) {
  return request({
    url: `/biz/userPayroll/packDownloadPayEncl`,
    method: 'post',
    responseType: 'arraybuffer',
    headers: {
      ignoreAuth: true
    },
    data
  })
}


//导出成本中心表
export function exportCostForms(obj) {
  return request({
    url: `/biz/bill-report-forms/exportCostForms`,
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  })
}

//导出成本中心表
export function exportCostFormsForHrCloud(obj) {
  return request({
    url: `/biz/bill-report-forms/exportCostFormsForHrCloud`,
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  })
}

// 获取发成本中心报表数据
export function costFormsList(obj) {
  return request({
    url: `/biz/bill-report-forms/costFormsList`,
    method: 'post',
    data: obj
  })
}

//获取成本中心报表表头
export function costListHeader(obj) {
  return request({
    url: `/biz/bill-report-forms/costListHeader`,
    method: 'post',
    data: obj
  })
}

export function getCostCenterList(cusId) {
  return request({
    url: `/biz/salarysetting/get-costcenter-by-cusid?cusId=${cusId}`,
    method: 'get'
  })
}
